@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.alertWrapper {
  padding:  hevo-toolkit-variables.$spacer;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.compact {
    flex-direction: row;
    justify-content: flex-start;
    margin-top:  hevo-toolkit-variables.$spacer;
    margin-bottom:  hevo-toolkit-variables.$spacer;

    .iconBox {
      margin-bottom: 0;
      margin-right:  hevo-toolkit-variables.$spacer;
      height: 48px;
      width: 48px;
      flex-shrink: 0;

      .icon {
        font-size: 24px;
      }
    }

    .text {
      align-items: flex-start !important;
    }
  }
}

.text {
  display: flex;
  flex-direction: column;
  align-items: center;
  .subtext {
    margin-top:  hevo-toolkit-variables.$spacer * 0.6 !important;
    word-break: break-word;
  }
}
